import 'ca-common';
import { register as registerCommonComponents } from 'ca-common/common-components';
import 'ca-dom-binding';

// Entry point styles
import './response.styles';

import 'ca-response-preview-setup/ResponsePreviewSetupApp.js';
import 'ca-assets/stylesheets/legacy/boilerplate.js';

import 'ca-assets/images/mask.svg';
import 'ca-assets/images/handarrow.svg';
import 'ca-assets/images/handarrow-flipped.svg';
import 'ca-assets/images/new_capture/capture-illustration.png';
import 'ca-assets/images/new_capture/capture-intro@1x.png';
import 'ca-assets/images/new_capture/capture-intro@2x.png';
import 'ca-assets/images/paper-plane.png';

import '@kaizen/component-library/icons/ca-monogram.icon.svg';
import '@kaizen/component-library/icons/check.icon.svg';
import '@kaizen/component-library/icons/chevron-down.icon.svg';
import '@kaizen/component-library/icons/chevron-right.icon.svg';
import '@kaizen/component-library/icons/chevron-left.icon.svg';
import '@kaizen/component-library/icons/close.icon.svg';
import '@kaizen/component-library/icons/comment.icon.svg';
import '@kaizen/component-library/icons/information.icon.svg';
import '@kaizen/component-library/icons/power.icon.svg';
import '@kaizen/component-library/icons/search.icon.svg';
import '@kaizen/component-library/icons/success.icon.svg';
import '@kaizen/component-library/icons/success-white.icon.svg';
import '@kaizen/component-library/icons/send.icon.svg';
import '@kaizen/component-library/icons/send-rtl.icon.svg';

import 'ca-assets/javascripts/response';
import 'ca-behaviours/external-search';
import 'ca-behaviours/online';
import 'ca-behaviours/toggle';
import 'ca-behaviours/modal';

import registerComponent from 'ca-react-automount';
import { ResetResponseButton } from 'ca-response-reset/ResetResponseButton';
import { GetStartedButton } from 'ca-capture/GetStartedButton/GetStartedButton';
import {
  FivePointRatingQuestion,
  ENPSElevenPointRatingQuestion,
} from 'ca-capture/RatingQuestion';
import SelectQuestion from 'ca-capture/SelectQuestion/SelectQuestion';
import FreeTextQuestion from 'ca-capture/FreeTextQuestion/FreeTextQuestion';
import CommentableSelectQuestion from 'ca-capture/CommentableSelectQuestion/CommentableSelectQuestion';
import NextButton from 'ca-capture/NextButton/NextButton';
import SubmitButtons from 'ca-capture/SubmitButtons/SubmitButtons';
import PostSurveyForm from 'ca-capture/PostSurvey/PostSurveyForm/PostSurveyForm';
import ValidationError from 'ca-capture/ValidationError/ValidationError';
import SelectLanguageLocale from 'ca-capture/SelectLanguageLocale/SelectLanguageLocale';
import { SkillsCoachSwitch } from '@cultureamp/skills-coach';
import { WelcomeScreen } from 'ca-welcome-screen';
import { CaLogo } from 'ca-logo';

import { registerComponent as defoRegisterComponent } from 'ca-dom-binding/registerReactComponents';

registerCommonComponents(registerComponent);

registerComponent('ResetResponseButton', ResetResponseButton);
registerComponent('GetStartedButton', GetStartedButton);
defoRegisterComponent('FivePointRatingQuestion', () => FivePointRatingQuestion);
defoRegisterComponent(
  'ENPSElevenPointRatingQuestion',
  () => ENPSElevenPointRatingQuestion
);
registerComponent('SelectQuestion', SelectQuestion);
registerComponent('FreeTextQuestion', FreeTextQuestion);
registerComponent('CommentableSelectQuestion', CommentableSelectQuestion);
registerComponent('NextButton', NextButton);
registerComponent('SubmitButtons', SubmitButtons);
registerComponent('PostSurveyForm', PostSurveyForm);
registerComponent('ValidationError', ValidationError);
registerComponent('SelectLanguageLocale', SelectLanguageLocale);
registerComponent('CaLogo', CaLogo);
defoRegisterComponent('SkillsCoachSwitch', () => SkillsCoachSwitch);
defoRegisterComponent('WelcomeScreen', () => WelcomeScreen);
